// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #253a85;
}

.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.centered {
  min-height: 80px !important;
  position: relative;
}

.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 80px;
  margin-left: 15px !important;
}

.loader-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loader-inline/loader-inline.component.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,2BAAA;EACA,2CAAA;AADJ;;AAIA;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBClBW;ADiBf;;AAIA;EACI,uBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,wBAAA;EACA,oBAAA;AADJ;;AAIA;EACI,wBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,wBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,sBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;AADJ;;AAIA;EACI;IACI,UAAA;EADN;EAIE;IACI,UAAA;EAFN;AACF;AAKA;EACI,2BAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAHJ","sourcesContent":["@import \"../../../styles/variables.scss\";\r\n\r\n.lds-spinner {\r\n    color: official;\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 80px;\r\n    height: 80px;\r\n}\r\n\r\n.lds-spinner div {\r\n    transform-origin: 40px 40px;\r\n    animation: lds-spinner 1.2s linear infinite;\r\n}\r\n\r\n.lds-spinner div:after {\r\n    content: \" \";\r\n    display: block;\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 37px;\r\n    width: 6px;\r\n    height: 18px;\r\n    border-radius: 20%;\r\n    background: $primary-blue;\r\n}\r\n\r\n.lds-spinner div:nth-child(1) {\r\n    transform: rotate(0deg);\r\n    animation-delay: -1.1s;\r\n}\r\n\r\n.lds-spinner div:nth-child(2) {\r\n    transform: rotate(30deg);\r\n    animation-delay: -1s;\r\n}\r\n\r\n.lds-spinner div:nth-child(3) {\r\n    transform: rotate(60deg);\r\n    animation-delay: -0.9s;\r\n}\r\n\r\n.lds-spinner div:nth-child(4) {\r\n    transform: rotate(90deg);\r\n    animation-delay: -0.8s;\r\n}\r\n\r\n.lds-spinner div:nth-child(5) {\r\n    transform: rotate(120deg);\r\n    animation-delay: -0.7s;\r\n}\r\n\r\n.lds-spinner div:nth-child(6) {\r\n    transform: rotate(150deg);\r\n    animation-delay: -0.6s;\r\n}\r\n\r\n.lds-spinner div:nth-child(7) {\r\n    transform: rotate(180deg);\r\n    animation-delay: -0.5s;\r\n}\r\n\r\n.lds-spinner div:nth-child(8) {\r\n    transform: rotate(210deg);\r\n    animation-delay: -0.4s;\r\n}\r\n\r\n.lds-spinner div:nth-child(9) {\r\n    transform: rotate(240deg);\r\n    animation-delay: -0.3s;\r\n}\r\n\r\n.lds-spinner div:nth-child(10) {\r\n    transform: rotate(270deg);\r\n    animation-delay: -0.2s;\r\n}\r\n\r\n.lds-spinner div:nth-child(11) {\r\n    transform: rotate(300deg);\r\n    animation-delay: -0.1s;\r\n}\r\n\r\n.lds-spinner div:nth-child(12) {\r\n    transform: rotate(330deg);\r\n    animation-delay: 0s;\r\n}\r\n\r\n@keyframes lds-spinner {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.centered {\r\n    min-height: 80px !important;\r\n    position: relative;\r\n}\r\n\r\n.loader-wrapper {\r\n    display: flex;\r\n    align-items: center; // miðjar loader og texta lóðrétt í röð\r\n    justify-content: center; // miðjar lárétt\r\n    gap: 16px; // bil á milli loader og texta\r\n    min-height: 80px; // tryggir pláss fyrir loader\r\n    margin-left: 15px !important;\r\n}\r\n\r\n.loader-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start; // eða `center` ef þú vilt textann miðjaðan lóðrétt\r\n}","// ------------ Fonts -------------\r\n$main-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n// ------------ MAIN COLORS -------------\r\n$primary-light-blue: #4695e7;\r\n$primary-lighter-blue: #5faffb;\r\n$primary-blue: #253a85;\r\n$primary-dark-blue: #082a54;\r\n$primary-pink: #e06902;\r\n$primary-pink-500: #e06902;\r\n\r\n$primary-200: #082a54;\r\n$primary-500: #253a85;\r\n$primary-800: #082a54;\r\n\r\n// Content\r\n$main-content-color: #f7f7f7;\r\n$light-weight-content: #f9fafd;\r\n$main-content-background-color: #fafafa;\r\n$main-text-color: rgba(0, 0, 0, 0.87);\r\n$loading-background: rgb(35 54 87);\r\n\r\n$gray-white: #d1ecf1;\r\n$white: rgb(255, 255, 255);\r\n$white-weak: rgb(255, 255, 255, 0.5);\r\n$white-hover: rgb(212, 212, 212);\r\n$darker-white: #fefefe;\r\n$mat-title-color: #1e293b;\r\n\r\n// GrayWhite\r\n$gray-white-color: #e9e9e9;\r\n$gray-white-color-hover: #f6f6f6;\r\n\r\n$background-color-soft-blue: rgb(35 54 87);\r\n\r\n// MBL colors\r\n$primary-mbl-green: #008800;\r\n\r\n// --------------------------------\r\n\r\n// ------------- ALERT-------------\r\n// Alert Dark Background\r\n$alert-b-color: #323130;\r\n\r\n// Alert color\r\n$alert-color: rgb(111, 2, 1);\r\n$alert-text-color: rgb(255, 255, 255);\r\n\r\n// Notification color\r\n$notification-color: #fa3e3e;\r\n\r\n// Alert yellow color\r\n$alert-yellow-color: #f6be00;\r\n$alert-yellow-color-light: rgb(253, 244, 164);\r\n$alert-b-color: #323130;\r\n\r\n$text-border: 1px solid rgba(0, 0, 0, 0.1);\r\n$box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\r\n\r\n$gray-scale-color: rgb(233, 235, 238);\r\n$gray-logo-color-light: rgb(173, 173, 173);\r\n$gray-logo-color: rgb(132, 132, 132);\r\n$success-color: rgb(83, 189, 120);\r\n\r\n$confirm-color-m: #53bd78;\r\n$alert-color-m: rgba(239, 191, 0, 1);\r\n$alert-safe: #eed202;\r\n$confirm-color-m-weak: rgba(81, 189, 119, 0.129);\r\n$alert-color-m-weak: rgba(239, 191, 0, 0.11);\r\n\r\n$panel-color: #323130;\r\n$lighter-dark: #3c4146;\r\n\r\n$basic-gray: #f1f5f9;\r\n$basic-fuse-gray: #64748b;\r\n\r\n$form-color: rgb(148, 168, 184);\r\n\r\n// --------------------------------"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
